import * as THREE from 'three';

// Twilight sky shader — five-band gradient with sun + horizon glow.
// Cooler purple zenith pairs with the new stars and moon for an actual
// dusk-into-night feel instead of straight orange.
export function createSky(sunDir) {
  const geo = new THREE.SphereGeometry(2400, 48, 32);

  const mat = new THREE.ShaderMaterial({
    side: THREE.BackSide,
    depthWrite: false,
    uniforms: {
      zenith:    { value: new THREE.Color(0x14102c) }, // near-night blue
      upperBand: { value: new THREE.Color(0x3c2c78) }, // deep twilight purple
      indigoBand:{ value: new THREE.Color(0x6c4c98) }, // soft indigo
      midBand:   { value: new THREE.Color(0xe89060) }, // warm peach
      lowerBand: { value: new THREE.Color(0xffc290) }, // honey
      groundBand:{ value: new THREE.Color(0xd87a58) }, // warm earth glow
      sunDir:    { value: sunDir.clone().normalize() },
      sunColor:  { value: new THREE.Color(0xfff0d0) }
    },
    vertexShader: /* glsl */`
      varying vec3 vDir;
      void main() {
        vDir = position;
        gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
      }
    `,
    fragmentShader: /* glsl */`
      uniform vec3 zenith;
      uniform vec3 upperBand;
      uniform vec3 indigoBand;
      uniform vec3 midBand;
      uniform vec3 lowerBand;
      uniform vec3 groundBand;
      uniform vec3 sunDir;
      uniform vec3 sunColor;
      varying vec3 vDir;

      void main() {
        vec3 d = normalize(vDir);
        float h = d.y;

        // five-band vertical gradient
        vec3 col = mix(groundBand, lowerBand, smoothstep(-0.2, 0.0, h));
        col = mix(col, midBand,    smoothstep(-0.05, 0.16, h));
        col = mix(col, indigoBand, smoothstep(0.16, 0.36, h));
        col = mix(col, upperBand,  smoothstep(0.36, 0.6, h));
        col = mix(col, zenith,     smoothstep(0.6, 0.92, h));

        // sun corona (tight)
        float sd = max(0.0, dot(d, sunDir));
        col += sunColor * pow(sd, 12.0) * 0.14;
        col += vec3(1.0, 0.78, 0.55) * pow(sd, 48.0) * 0.32;
        float disk = smoothstep(0.9985, 0.9995, sd);
        col += sunColor * disk * 2.2;

        // horizon glow band (warm halo at h~0)
        float horizon = exp(-pow(h * 7.5, 2.0));
        col += vec3(1.0, 0.7, 0.4) * horizon * 0.10;

        gl_FragColor = vec4(col, 1.0);
      }
    `
  });

  const mesh = new THREE.Mesh(geo, mat);
  mesh.frustumCulled = false;
  mesh.renderOrder = -1;
  return { mesh, material: mat };
}
